import { generateDefaultState, getActionTypes } from '../../../utils/reduxHelper';

export const actions = getActionTypes('intOutBoundFile', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SET_FILTERS',
    'GET_FILE_LOG'
]);
export const initialIntOutBoundFileState = {
    ...generateDefaultState('intOutBoundFile', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SET_FILTERS',
        'GET_FILE_LOG'
    ]),
};
